import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import "modules/AccessKeysDashboard/components/LocationIdsModal/LocationIdsModal.scss";

type LocationIdsModalProps = {
  open: boolean;
  onClose: () => void;
};

export const LocationIdsModal = ({ onClose, open }: LocationIdsModalProps) => {
  const { t } = useTranslation();
  const { selectedDealer } = useSelectedDealer();

  return (
    <Modal open={open} onClose={onClose} className="LocationIdsModal">
      <Modal.Header className="logs-title">
        {t("v8_location_ids", "Location ID's")}
        <div className="close-button-container">
          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark grey" size="big" />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Content scrolling>
        {selectedDealer?.locations?.map(location => (
          <div key={location.id} className="location-ids-container">
            <span className="text">{location.name}</span>
            <span className="text"> {location.id} </span>
          </div>
        ))}
      </Modal.Content>
    </Modal>
  );
};
